import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";

const ReasonFormModal = (props) => {
  let [name, setName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  let [jobstatus, setJobstatus] = useState({});
  const [validate, setValidate] = useState(false);
  const [jobError, setJobError] = useState(false);
  const [deptError, setDeptError] = useState(false);
  let [reasonStatus, setReasonStatus] = useState("Active");
  const { t } = useTranslation();
  const formRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.data.reasonCode) {
      setName(props?.data?.reasonName);
      setId(props?.data?.reasonCode);
      setReasonStatus(props?.data?.reasonStatus);
      setDeptCode(props?.data?.deptCode);
      setDeptName(props?.data?.deptName);
      setJobstatus({
        jobstatusCode: props.data.jobstatusCode,
        jobstatusName: props.data.jobstatusName,
      });
            setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (event) => {
    const form = formRef.current;
    if (!jobstatus.jobstatusCode ) {
      setJobError(true);
      return 
    } else if (!deptCode ) {
      setDeptError(true);
      return 
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const reasonObj = {
        deptCode,
        deptName,
        reasonName: name,
        reasonCode: id,
        reasonStatus: reasonStatus,
        jobstatusName: jobstatus.jobstatusName,
        jobstatusCode: jobstatus.jobstatusCode,
      };
      if (edit) {
        reasonObj._id = props.data._id;
      }
      props.onSave(reasonObj, edit);
      setName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setName("");
    setId("");
    props.onHide();
  };

  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store
  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
  deptList &&
  deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

  let jobStatusList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.JOBSTATUS.name]?.data
  ); // User Details from Store
  useEffect(() => {
    if (!jobStatusList) {
      dispatch(fetchMasterList(Constants.MASTER.JOBSTATUS));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobStatusList]);

  const jobStatusResult =
    jobStatusList &&
    jobStatusList.map(({ jobstatusCode, jobstatusName }) => ({
      jobstatusCode,
      jobstatusName,
    }));
    
  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={edit? t("msg_master_list.msg_reason.edit_page_title") : t("msg_master_list.msg_reason.page_title")}
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_reason.select_jobstatus")}
            </Form.Label>
            <DropdownListField
              id="jobstatusCode"
              name="jobstatusName"
              className="dropdownHive w-full rounded-md"
              data={jobStatusResult}
              value={jobstatus?.jobstatusName}
              onChange={(value) => {setJobstatus(value); setJobError(false)}}
              placeholder={t("msg_master_list.msg_reason.select_jobstatus")}
              autoFocus={true}
              error={jobError}
              disabled={!jobStatusResult}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_checklist.select_department")}
            </Form.Label>
            <DropdownListField
              id="deptCode"
              name="deptName"
              className="dropdownHive w-full rounded-md"
              data={deptResult}
              value={deptCode}
              onChange={(value) => {
                setDeptCode(value?.deptCode);
                setDeptName(value?.deptName);
                setDeptError(false);
              }
              }
              required
              placeholder={t("msg_master_list.msg_machines.select_department")}
              autoFocus={true}
              error={deptError}
              disabled={!deptResult}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_reason.code")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: RES-001"
              value={id || ""}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_reason.reason_code_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_reason.reason_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={name || ""}
              onChange={(e) => setName(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_reason.reason_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              value={reasonStatus}
              onChange={(e) => setReasonStatus(e.target.value)}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReasonFormModal;
